// extracted by mini-css-extract-plugin
export default {"title":"Header_title__q6ZPk","subTitleBlock":"Header_subTitleBlock__iQr+U","subTitle":"Header_subTitle__BEYy+","images":"Header_images__RanNe"};